import { render, staticRenderFns } from "./agreeMent.vue?vue&type=template&id=38b460db&scoped=true&"
import script from "./agreeMent.vue?vue&type=script&lang=js&"
export * from "./agreeMent.vue?vue&type=script&lang=js&"
import style0 from "./agreeMent.vue?vue&type=style&index=0&id=38b460db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b460db",
  null
  
)

export default component.exports